import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";

export const SignInButton = () => {
	const { instance } = useMsal();

	const handleLogin = (loginType: "popup" | "redirect") => {
		// for some reason I cannot get the login popup to work
		if (loginType === "popup") {
			instance
				.loginPopup(loginRequest)
				.then(() => {
					// Reload page to refresh account state after successful login
					console.log("hello");
				})
				.catch((e) => {
					console.log(e);
				});
		} else if (loginType === "redirect") {
			instance.loginRedirect(loginRequest).catch((e) => {
				console.log(e);
			});
		}
	};
	return (
		// <DropdownButton variant="secondary" className="ml-auto" drop="start" title="Sign In">
		//     <Dropdown.Item as="button" onClick={() => handleLogin("popup")}>Sign in using Popup</Dropdown.Item>
		//     <Dropdown.Item as="button" onClick={() => handleLogin("redirect")}>Sign in using Redirect</Dropdown.Item>
		// </DropdownButton>
		<button
			onClick={() => handleLogin("redirect")}
			className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
		>
			<span>🔐</span>
			Sign in with Microsoft
		</button>
	);
};
